import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api-service';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';

@Injectable()
export class SellerService extends BaseApiService {
  sellerCachedObservables: any = {};

  constructor(private http: HttpClient, private auth: AuthService) {
    super();
  }

  getAllData(sellerId: string) {
    const query = `WHERE sellerId = '${sellerId}'`;
    const urlString =
      `${this.getReportBaseUrl(
        '2018'
      )}/getWidget?q=${query}&reportId=sellerMrt&` + `widgetId=sellerSummary`;
    return this.getCachedObservable(urlString);
  }

  getCachedObservable(urlString: string) {
    const cacheKey = `${this.auth.getAuthState()}:${urlString}`;
    let cachedObservable = this.sellerCachedObservables[cacheKey];

    if (!cachedObservable) {
      cachedObservable = this.http.get(urlString).pipe(shareReplay());
      this.sellerCachedObservables[cacheKey] = cachedObservable;
    }

    return cachedObservable.toPromise();
  }
}
